import { useSession } from "@/composables/useSession";
import { enterIncognito, exitIncognitoMode } from "@/services/internalApiV1";

export function useIncognito(): {
  loginAs: (userId: string) => Promise<void>;
  logout: () => Promise<void>;
} {
  const userStore = useUserStore();
  const incognitoStore = useIncognitoStore();

  const queryClient = useQueryClient();

  const { refetchUser } = useSession();

  const route = useRoute();

  const loginAs = async (userId: string): Promise<void> => {
    incognitoStore.path = route.fullPath;

    try {
      await enterIncognito(userId);

      userStore.reset();

      queryClient.clear();

      await refetchUser();
    } catch (error) {
      incognitoStore.$reset();
      console.error(error);
      throw error;
    }
  };

  const logout = async (): Promise<void> => {
    try {
      await exitIncognitoMode();

      userStore.reset();
      incognitoStore.$reset();

      queryClient.clear();

      await refetchUser();
    } catch (error) {
      console.error(error);
    }
  };

  return {
    loginAs,
    logout,
  };
}
